import { ColorInput } from '@infotech-soe/erp-ui-kit';
import React, { useCallback } from 'react';

import {
  numDecBGRToStrHexRGB,
  strHexRGBToNumDecBGR,
} from '../../../framework/colors/colorConversion';
import { ColorInputFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getGeneralConfig } from '../../../store/selectors/userConfig';
import userConfig from '../../../store/slices/userConfig';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';

interface Props extends Omit<TFormControlConnectorProps, 'onChange'> {
  control: ColorInputFormControlViewModel;
  onChange: (value: string | number | null) => void;
}

const convertFromPropValue = (
  control: ColorInputFormControlViewModel
): string | null =>
  control.value !== null ? numDecBGRToStrHexRGB(control.value) : null;

const FormColorInputControl = ({
  areHintsShown,
  control,
  onChange,
}: Props): React.JSX.Element => {
  const rgbValue = convertFromPropValue(control);

  const convertToPropValue = (color: string | null) =>
    color !== null ? strHexRGBToNumDecBGR(color) : null;

  const handleChange = (val: string | null) => {
    onChange?.(convertToPropValue(val));
  };

  const { presetColors: userPresetColors } = useAppSelector(getGeneralConfig);
  const dispatch = useAppDispatch();

  // TODO: fix it in ui-kit - get rid of useEffect
  const handleClosePreset = useCallback(
    (presetColors: string[]) => {
      dispatch(userConfig.saveGeneral({ config: { presetColors } }));
    },
    [dispatch]
  );

  return (
    <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
      <ColorInput
        value={rgbValue}
        canClearOnReadOnly={control.canClearOnReadOnly}
        disabled={control.disabled}
        readOnly={control.readonly}
        required={control.required}
        userPresetColors={userPresetColors}
        onChange={handleChange}
        onClosePreset={handleClosePreset}
        // TODO fix in ua-kit
        onClear={() => onChange(null)}
      />
    </FormLabeledInputControl>
  );
};

export default FormColorInputControl;
